var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GeneralSettings'),_vm._v(" "),_c('AllowedGroups'),_vm._v(" "),_c('Commands'),_vm._v(" "),_c('StunServers'),_vm._v(" "),_c('TurnServers'),_vm._v(" "),_c('SignalingServers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }